import styles from 'components/footer/footer.module.css';

import { useTranslation } from 'react-i18next';
import { Menu } from 'components/menu/Menu';
import { SocialIcons } from 'components/socialIcons/SocialIcons';
import { useRedirectToHome } from 'hooks/redirect.hooks';
import { LogoBeigeFooter } from 'components/vectors/LogoBeigeFooter';

export const Footer = () => {
    const { t } = useTranslation();
    const redirectToHome = useRedirectToHome();

    return (
        <div className={styles.footer}>
            <div className={styles.footer__logo} onClick={redirectToHome}>
                <LogoBeigeFooter />
            </div>
            <div className={styles.footer__menu}>
                <Menu isFooter={true} />
            </div>
            <div className={styles.footer__socials}>
                <SocialIcons />
            </div>
            <p>{t('footer.madeInFrance')}</p>
        </div>
    );
};
